/**
 * Canonical public legal document URLs for this brand.
 * Used by Clerk express consent (Dashboard / instance config),
 * CookieBanner, and membership registration links.
 */
import { BRAND_SITE_URL } from "@/lib/brandConfig";

const base = BRAND_SITE_URL.replace(/\/$/, "");

/** Terms of Service — Clerk `compliance.legal_consent.terms_of_service_url` */
export const TERMS_OF_SERVICE_PATH = "/terminos-y-condiciones";
export const TERMS_OF_SERVICE_URL = `${base}${TERMS_OF_SERVICE_PATH}`;

/** Privacy Policy — Clerk `compliance.legal_consent.privacy_policy_url` */
export const PRIVACY_POLICY_PATH = "/privacy-policy";
export const PRIVACY_POLICY_URL = `${base}${PRIVACY_POLICY_PATH}`;

/** Spanish alias for privacy policy */
export const PRIVACY_POLICY_ES_PATH = "/politica-de-privacidad";
